import React from "react";
import PropTypes from "prop-types";

/**
 * SuggestionItemText component
 *
 * @param {Object} props - The component props
 * @param {string} props.text - The suggestion text to be displayed
 * @param {string} props.query - The current search query
 *
 * @returns {JSX.Element} The rendered SuggestionItemText component. It has the text adjusted to the container's width.
 */
const SuggestionItemText = ({ text, query }) => {
  const cleanedSuggestion = text.replaceAll(" | WaFd Bank", ""); // Clean the suggestion text
  const lowerSuggestion = cleanedSuggestion.toLowerCase(); // Lowercase for display
  const lowerSearched = query.toLowerCase(); // Lowercase for comparison

  const isSearchedResult = lowerSuggestion === lowerSearched;
  const isSearchInResult = lowerSuggestion.includes(lowerSearched);

  if (!isSearchedResult && isSearchInResult) {
    const startIndex = lowerSuggestion.indexOf(lowerSearched);
    const endIndex = startIndex + lowerSearched.length;

    const lightText1 = lowerSuggestion.slice(0, startIndex); // Text before match
    const boldText = lowerSuggestion.slice(startIndex, endIndex); // Matched text
    const lightText2 = lowerSuggestion.slice(endIndex); // Text after match

    return (
      <span className="ss-item-text">
        {lightText1}
        <strong>{boldText}</strong>
        {lightText2}
      </span>
    );
  } else {
    return <span className="ss-item-text">{lowerSuggestion}</span>;
  }
};

export default SuggestionItemText;

SuggestionItemText.propTypes = {
  text: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired
};
